module.exports = __webpack_public_path__ + "assets/0814dbd2dc494e4c95a5d2f5db37cbc5.png";